

const transformSchedMsg = (schedmsgs) => {
    return schedmsgs.map((schedule) => {
        const { key, sched } = schedule;
        return {
            ...schedule,
            key,
            sched: sched && parseInt(schedule.sched) !== 0 ? sched : ''
        }
    })
}

export default transformSchedMsg;